<template>
  <div style="height: 100%;">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
};
</script>

<style scoped lang="scss">
</style>
